import { render, staticRenderFns } from "./PutOnTest.vue?vue&type=template&id=5808aa1e&scoped=true"
import script from "./PutOnTest.vue?vue&type=script&lang=ts"
export * from "./PutOnTest.vue?vue&type=script&lang=ts"
import style0 from "./PutOnTest.vue?vue&type=style&index=0&id=5808aa1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808aa1e",
  null
  
)

export default component.exports